<template>
  <div id="app">
    <table v-if="display === 'ranking'" class="table">
      <transition-group tag="tbody" name="fade">
        <tr
          v-for="user in displayedRanks"
          :key="user.key"
          class="rank"
          :class="{ mainUser: user.name === streamerName }"
        >
          <td class="user-rank">
            <transition name="fade" mode="out-in">
              <span
                :key="user.rank"
                :class="{
                  first: user.rank == 1,
                  second: user.rank == 2,
                  third: user.rank == 3
                }"
              >
                {{ user.rank }}</span
              >
            </transition>
          </td>
          <td class="user">
            <div class="class-icon" :class="user.breed" />
            <div>{{ user.name }}</div>
          </td>
          <td>{{ user.server }}</td>

          <td>
            <transition name="fade" mode="out-in">
              <span :key="user.points">{{ user.points }}</span>
            </transition>
          </td>
        </tr>
      </transition-group>
    </table>
    <table v-else-if="display === 'solo' && userRankInfo" class="table solo">
      <tbody>
        <tr
          class="rank"
          :class="{ mainUser: userRankInfo.name === streamerName }"
        >
          <td class="user-rank">
            <transition name="fade" mode="out-in">
              <span
                :key="userRankInfo.rank"
                :class="{
                  first: userRankInfo.rank == 1,
                  second: userRankInfo.rank == 2,
                  third: userRankInfo.rank == 3
                }"
              >
                {{ userRankInfo.rank }}</span
              >
            </transition>
          </td>
          <td class="user">
            <div class="class-icon" :class="userRankInfo.class" />
            <div>{{ userRankInfo.name }}</div>
          </td>
          <td class="points">
            <div>{{ userRankInfo.points }}</div>
          </td>

          <td>
            <transition name="fade" mode="out-in">
              <span :key="userRankInfo.points">{{ userRankInfo.level }}</span>
            </transition>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-else-if="display === 'solo-fancy' && userRankInfo"
      class="solo-fancy"
    >
      <div
        class="rank"
        :class="{ mainUser: userRankInfo.name === streamerName }"
      >
        <div class="user-rank">
          <transition name="fade" mode="out-in">
            <span
              :key="userRankInfo.rank"
              :class="{
                first: userRankInfo.rank == 1,
                second: userRankInfo.rank == 2,
                third: userRankInfo.rank == 3
              }"
            >
              {{ userRankInfo.rank }}
            </span>
          </transition>
        </div>
        <div class="user">
          <div>{{ userRankInfo.name }}</div>
        </div>
        <div class="points">
          <div>{{ userRankInfo.points }} Points</div>
        </div>

        <div>
          <transition name="fade" mode="out-in">
            <span :key="userRankInfo.points">{{ userRankInfo.level }}</span>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      streamerName: "Titatitutu",
      display: "ranking"
    };
  },
  computed: {
    ladder() {
      return this.$dofus.ranking.slice(1);
    },
    userRank() {
      return this.ladder.findIndex(item => item.name === this.streamerName) + 1;
    },
    userRankInfo() {
      return this.ladder[this.userRank - 1];
    },
    displayedRanks() {
      if (this.ladder.length) {
        if (this.userRank === 1 || this.userRank === 2) {
          return [
            this.ladder[0],
            this.ladder[1],
            this.ladder[2],
            this.ladder[3],
            this.ladder[4]
          ];
        } else if (
          this.userRank === 100 ||
          this.userRank === 99 ||
          this.userRank === 98
        ) {
          return [
            this.ladder[0],
            this.ladder[96],
            this.ladder[97],
            this.ladder[98],
            this.ladder[99]
          ];
        } else if (this.userRank !== 0) {
          const rank = this.userRank - 1;

          return [
            this.ladder[0],
            this.ladder[rank - 2],
            this.ladder[rank - 1],
            this.ladder[rank],
            this.ladder[rank + 1]
          ];
        } else {
          return [
            this.ladder[0],
            this.ladder[1],
            this.ladder[2],
            this.ladder[98],
            this.ladder[99]
          ];
        }
      }

      return [];
    }
  },
  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    this.streamerName = urlParams.get("streamer") || "Crymoh";
    this.display = urlParams.get("display") || "ranking";
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

html,
body {
  padding: 0;
  margin: 0;
}

td {
  margin: 0;
}

table {
  border-spacing: 0;
}

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

.fade-move {
  transition: transform 0.3s 0.3s;
}
</style>
<style scoped lang="scss">
.solo-fancy {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);
  padding: 0.5rem;
  margin: 2rem;
  border-radius: 1rem;

  background: #f3f2ed !important;
  text-align: center;
  .rank {
    background: #f3f2ed !important;
    color: #362712 !important;
  }
  .user {
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
  }
  .points {
    font-weight: normal;

    font-size: 0.8rem;
  }

  .user-rank :not(.first):not(.second):not(.third) {
    background: #362712;
    color: #ffffff;
    box-shadow: inset 0 0 3px 2px #8a6d42;
  }
}
table.solo {
  width: 250px;
  margin: 2rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);
}
.rank td {
  padding: 0.5rem;
}

.rank:first-child {
  background: url(assets/bg_td_first.jpg) 0 0 repeat #f8f8f6;
  color: #fff;
  border-color: #b1ac9c;
}

.rank:not(:first-child) {
  border-collapse: collapse;
  border-bottom: solid 1px #b1ac9c;
  color: #362712;
  background: #f3f2ed;
}

.rank:not(:first-child) td {
  border-bottom: solid 1px #b1ac9c;
}

.user-rank {
  text-align: center;
}

.user-rank span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
}

.user-rank .first,
.user-rank .second,
.user-rank .third {
  font-size: 2rem;
  font-weight: bold;
}

.user-rank .first {
  background: #ffba00;
  color: #ffffff;
  box-shadow: inset 0 0 3px 2px #ffe300;
}

.user-rank .second {
  background: #b6b6b6;
  color: #eeeeee;
  box-shadow: inset 0 0 3px 2px #ddddcd;
}

.user-rank .third {
  background: #ff6100;
  color: #ffbb3f;
  box-shadow: inset 0 0 3px 2px #ff9b00;
}

.table {
  width: 450px;
}

@for $i from 1 through 18 {
  .class-icon.breed#{$i}_0 {
    background-position: -($i - 1) * 35px -35px;
  }
  .class-icon.breed#{$i}_1 {
    background-position: -($i - 1) * 35px 0;
  }
}

.user {
}

.user div {
  display: inline-flex;
  vertical-align: middle;
}

.class-icon {
  display: inline-block;
  height: 35px;
  position: relative;
  width: 35px;
  background-image: url(assets/breeds.jpg);
  margin-right: 0.5rem;
}

.rank.mainUser {
  font-weight: bold;
}
</style>
